const CLOUDFRONT_BASE = process.env.REACT_APP_CLOUDFRONT_BASE;
const CLOUDFRONT_PREFIX = `${CLOUDFRONT_BASE}`;

export const COUNTRIES_JSON = `${CLOUDFRONT_PREFIX}/countries.json`;
export const STATES_JSON = `${CLOUDFRONT_PREFIX}/states.json`;
export const CITIES_JSON = `${CLOUDFRONT_PREFIX}/cities.json`;
export const STATES_CITIES_JSON = `${CLOUDFRONT_BASE}/states%2Bcities.json`;

export const COUNTRIES_STATES_CITIES_JSON = (countryId: number) => 
  `${CLOUDFRONT_BASE}/states-by-country/${countryId}.json`;

